import React from 'react';
import { CTAButton } from './CTAButton';
import { Check } from 'lucide-react';
export function MegapackShowcase() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-gray-900 text-white py-20 px-4 relative overflow-hidden" data-id="element-171">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-172"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-173">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-16 text-white" data-id="element-174">
          Mira{' '}
          <span className="text-yellow-400 underline decoration-wavy decoration-4" data-id="element-175">
            TODO
          </span>{' '}
          lo que recibes hoy
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12" data-id="element-176">
          {/* Left: Image */}
          <div className="cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/dzpTiA5J7f6dbvyhvYyYrH/portada_kit_educativo_completo.png" alt="Kit Educativo Completo" className="w-full h-auto drop-shadow-[0_0_30px_rgba(255,255,255,0.15)] rounded-2xl border-4 border-gray-800" data-id="element-178" />
          </div>

          {/* Right: Value Stack */}
          <div className="bg-gray-800 p-8 rounded-3xl border-2 border-gray-700 shadow-2xl relative" data-id="element-179">
            <div className="absolute -top-5 -right-5 bg-yellow-400 text-black font-black w-20 h-20 rounded-full flex items-center justify-center rotate-12 shadow-lg border-4 border-gray-900 z-20 text-center text-sm leading-tight" data-id="element-180">
              ¡Mejor
              <br data-id="element-181" />
              Valor!
            </div>

            <ul className="space-y-4 mb-8" data-id="element-182">
              <li className="flex justify-between items-center border-b border-gray-700 pb-3" data-id="element-183">
                <span className="font-bold text-lg flex items-center gap-2" data-id="element-184">
                  <Check className="w-5 h-5 text-green-400" data-id="element-185" /> Mega Pack
                  Anti-Pantallas
                </span>
                <span className="font-bold text-gray-400" data-id="element-186">$19,990</span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-700 pb-3 text-yellow-300" data-id="element-187">
                <span className="font-bold flex items-center gap-2" data-id="element-188">
                  <Check className="w-5 h-5 text-yellow-300" data-id="element-189" /> Bono 1:
                  Matemáticas
                </span>
                <span className="font-bold" data-id="element-190">$10,000</span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-700 pb-3 text-yellow-300" data-id="element-191">
                <span className="font-bold flex items-center gap-2" data-id="element-192">
                  <Check className="w-5 h-5 text-yellow-300" data-id="element-193" /> Bono 2:
                  Emociones
                </span>
                <span className="font-bold" data-id="element-194">$10,000</span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-700 pb-3 text-yellow-300" data-id="element-195">
                <span className="font-bold flex items-center gap-2" data-id="element-196">
                  <Check className="w-5 h-5 text-yellow-300" data-id="element-197" /> Bono 3:
                  Estimulación
                </span>
                <span className="font-bold" data-id="element-198">$10,000</span>
              </li>
            </ul>

            <div className="flex justify-between items-end mb-2 px-4" data-id="element-199">
              <span className="text-xl font-medium text-gray-400" data-id="element-200">
                Valor Total Real:
              </span>
              <span className="text-3xl font-bold text-red-400 line-through decoration-2" data-id="element-201">
                $89,990
              </span>
            </div>

            <div className="bg-gray-900 rounded-2xl p-4 flex justify-between items-center mb-8 border border-gray-700" data-id="element-202">
              <span className="text-xl font-bold text-white" data-id="element-203">Precio Hoy:</span>
              <span className="text-5xl font-black text-green-400" data-id="element-204">
                $19,990
              </span>
            </div>

            <p className="text-center text-sm text-gray-400 mb-6 bg-gray-900/50 py-2 rounded-lg" data-id="element-205">
              *Oferta digital de descarga inmediata
            </p>

            <CTAButton text="¡ACCEDER A TODO POR $19,990!" className="w-full" href="https://recursoseducapro.shop/cart/47652553720046:1" data-id="element-206" />
          </div>
        </div>
      </div>
    </section>;
}